<template>
	<div class="board">
		<van-nav-bar title="控制-面板" left-text="返回" left-arrow @click-left="goBack" />
		<van-tabs v-model="active">
			<van-tab title="成绩信息">
				<div class="idcard-item">
					<span class="idcard-item-label">身份证:</span>
					<span class="idcard-item-content"
						v-if="studentInfor.member">{{studentInfor.member.member_idcard}}</span>
				</div>
				<div class="idcard-item">
					<span class="idcard-item-label">手机号:</span>
					<span class="idcard-item-content"
						v-if="studentInfor.member">{{studentInfor.member.member_mobile}}</span>
				</div>
				<div class="idcard-item">
					<span class="idcard-item-label">出勤情况:</span>
					<span class="idcard-item-content">{{studentInfor.turn}}</span>
				</div>
				<div class="idcard-item">
					<span class="idcard-item-label">成果成绩:</span>
					<span class="idcard-item-content">{{studentInfor.gain}}</span>
				</div>
				<div class="idcard-item">
					<span class="idcard-item-label">规划成绩:</span>
					<span class="idcard-item-content">{{studentInfor.plan}}</span>
				</div>
				<div class="idcard-item">
					<span class="idcard-item-label">理论成绩:</span>
					<span class="idcard-item-content">{{studentInfor.theory_score}}</span>
				</div>
			</van-tab>
			<van-tab title="班级信息">
				<div class="idcard-item">
					<span class="idcard-item-label">班级名称:</span>
					<span class="idcard-item-content"
						v-if="studentInfor.member">{{studentInfor.member.class_name}}</span>
				</div>
				<div class="idcard-item">
					<span class="idcard-item-label">教师名称:</span>
					<span class="idcard-item-content"
						v-if="studentInfor.member">{{studentInfor.member.teacher_name}}</span>
				</div>
				<div class="idcard-item">
					<span class="idcard-item-label">培训时间:</span>
					<span class="idcard-item-content">{{studentInfor.start_time}}</span>
				</div>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import { getStudentIndex } from '../../../api/student'
	export default {
		name: 'Board',
		components: {
		},
		props: [],
		data() {
			return {
				// 启动
				active: 1,
				// 学生信息
				studentInfor: {}
			}
		},
		methods: {
			goBack() {
				this.$router.go(-1)
			},
		},
		created() {
			getStudentIndex().then(res => {
				if (res.code === 10000) {
					this.studentInfor = res.result
				}
				// console.log(res)
			}).catch(error => {
				this.$router.push('Home')
			})
		}
	}
</script>

<style lang="scss" scoped>
	.board {
		font-size: 12px;
		color: #606266;

		.home-title {
			display: flex;
			align-items: center;
			padding: 10px;
			font-size: 14px;
			color: white;
			background-color: #e93b3d;

			.first {
				margin-right: 10px;
			}

			.oprate {
				position: relative;

				.oprate-block {
					width: 80px;
					position: absolute;
					top: 5px;
					right: 0px;
					background-color: #e93b3d;
					text-align: center;
					border-radius: 5px;

					.oprate-item {
						margin-bottom: 5px;
					}
				}
			}
		}

		.idcard-item {
			padding: 5px 20px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #EEEEEE;

			.idcard-item-label {
				text-align-last: right;
				margin-right: 5px;
				font-weight: bold;
			}
		}
	}

	.board   ::v-deep.van-nav-bar {
		background-color: #e93b3d;
		color: white;

		.van-icon-arrow-left,
		.van-nav-bar__title,
		.van-nav-bar__text {
			color: white;
		}
	}
</style>